import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollSmoother} from 'gsap/ScrollSmoother'
import 'is-in-viewport'
import {onScroll} from './transition'

gsap.registerPlugin(ScrollSmoother, ScrollTrigger)

function allElementsExist() {
  for (const c of arguments) {
    if (!document.querySelector(c)) {
      return false
    }
  }
  return true
}

const scrollSmoother = ScrollSmoother.create({
  smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
  speed: 1,
  // smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  effects: true, // looks for data-speed and data-lag attributes on elements
  onUpdate: (self) => {
    onScroll(self);
    onUpdateScrollMenu(self);
  },
  onStop: () => onScroll,
})

function onUpdateScrollMenu (self) {
  const scrollTarget = $('html')
  const velocity = self.getVelocity();

  scrollTarget.addClass('scrolling').removeClass('at-top')

  const hasHero = !!document.querySelector('body.first-block-heroblock');
  const atTop = self.scrollTop() <= ((hasHero) ? $(window).height() * 0.4 : 1);

  if (!atTop) {
    if (velocity > 0) {
      scrollTarget.addClass('scroll-down').removeClass('scroll-up')
    } else if (velocity < 0) {
      scrollTarget.removeClass('scroll-down').addClass('scroll-up')
    }
  } else {
    scrollTarget.removeClass('scroll-down scrolling scroll-up').addClass('at-top')
  }
}


ScrollTrigger.config({ignoreMobileResize: true})
ScrollTrigger.normalizeScroll(true)

$(() => {
  // Hero
  if (allElementsExist('.hero-content')) {
    ScrollTrigger.create({
      trigger: '.hero-content',
      start: 'top top',
      end: () => `+=${0.4 * window.innerHeight}`,
      pin: true,
      // markers: true,
      pinSpacing: false,
      scrub: false,
    })
  }
})
